import { Paginator } from 'primereact/paginator';

const CustomPaginator = ({ totalRows, rowsCount, first, onPageChange }) => {

    return (
        <div className='paginator-wrapper'>
            <div className='paginator-left'>
            {totalRows === 0 ? 
            `Showing 0 to ${Math.min(first + rowsCount, totalRows)} of ${totalRows} entries` : 
            `Showing ${first + 1} to ${Math.min(first + rowsCount, totalRows)} of ${totalRows} entries`}
            </div>
            <div className='paginator-right'>
                <div className="card">
                    <Paginator
                        first={first}
                        rows={rowsCount}
                        totalRecords={totalRows}
                        onPageChange={onPageChange}
                        className={'custom-pagination'}
                        template={{ layout: "PrevPageLink PageLinks NextPageLink" }}
                    />
                </div>
            </div>
        </div>
    );
};

export default CustomPaginator;

